module.exports = __webpack_public_path__ + "static/media/stickers.107ad2b6.svg";